import {FulltextSearch} from '@/api/meta/filters';
import {autoImplement} from '@/util';
import moment from 'moment';
import {ApiFile} from './File';

export interface ApiBillPositions {
  PosNr: number,
  Artikel: {
    ArtikelNr: number,
    ArtikelBezeichnung1: string,
    ArtikelBezeichnung2: string,
  },
  Einheit: {
    Menge: number,
    Einheit: string,
  },
  Preise: {
    EinheitsPreis: number,
    NettoBetrag: number,
  }
}

export interface ApiBill {
  RechnungNr: number,
  RechnDatum: string,
  BuchDatum: string,
  Status: number,
  RechnArt: number,
  Gutschrift: string,
  AlteRechnungNr: number,
  Stornogrund: unknown | null,
  Bediener: string,
  Vertreter: string,
  Kommission: string,
  Einkaufverkauf: string,
  Bezeichnung: string,
  KundenNr: number,
  Debitorkto: number,
  SkontoTage1: number,
  SkontoProzent1: number,
  SkontoTage2: number,
  SkontoProzent2: number,
  NettoTage: number,
  ValutaDatum: unknown | null,
  Faelligabdatum: string,
  Lastschrift: 'N' | 'J',
  ZahlungsbedingungText: string,
  StreckeNr: number,
  USTIDMandant: string,
  USTIDKunde: string,
  SteuerNrKunde: string,
  RechnSammelListeNr: unknown | null,
  FremdWaehrung: string,
  Umrkurs: number,
  Lfdrechnnr: number,
  Rechnadrnr: number,
  BankName: string,
  BIC: string,
  IBAN: string,
  AbschlRechnBelegArt: unknown | null,
  AbschlRechnBelegNr: unknown | null,
  Rechnungnrkunde: string,
  Selbstabrechner: 'J' | 'N',
  BestNrKd: string,
  GesamtNetto: number,
  GesamtMwSt: number,
  GesamtBrutto: number,
  Skontierfaehig: number,
  AusgangsRechnungPositionen?: ApiBillPositions[];
  Archiv?: { Values: ApiFile[] | null },
  Dateien?: { Values: ApiFile[] };
}

export interface BillFilters {
  KundenNr?: number;
  AuftragNr?: number;
  Erledigt?: boolean;
  Fulltext$Fulltext: FulltextSearch;
}
export interface DetailBillFilters {
  KundenNr?: number;
  AuftragNr?: number;
}

export default class Bill extends autoImplement<ApiBill>() {
  static fromApi(apiBill: ApiBill): Bill {
    return new Bill(apiBill);
  }

  get RechnDatumFormatted() {
    return moment(this.RechnDatum).format('DD.MM.YYYY');
  }
}
